import httpClient from '@utils/httpClient';
import {SERVICE_NAMES} from '../constants';
import {createApiCall, getApiUrl} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    FastTrackUrlsResource,
    FastTrackResource,
    StoreBulkRequest,
    StoreFastTrackRequest,
    StoreFastTrackResponse,
    FastTrackUrlsParams
} from './api.d';

const BULK_SERVICE_NAME = SERVICE_NAMES.BULK as ServiceName;

const createBulkApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(BULK_SERVICE_NAME, method, endpoint);

export const bulkApi = {
    storeBulk: async ({accountId, templateId, data, options}: {accountId: string; templateId: string; data: StoreBulkRequest; options?: ApiCallOptions}) => {
        const endpoint = `accounts/${accountId}/templates/${templateId}/bulk`;
        const url = await getApiUrl(BULK_SERVICE_NAME, endpoint);

        const formData = new FormData();
        formData.append('csv_file', data.csvFile);

        if (data.name) {
            formData.append('name', data.name);
        }

        const config: any = {
            method: 'post',
            url,
            data: formData,
            headers: {}
        };

        if (options?.accessToken) {
            config.headers.Authorization = `Bearer ${options.accessToken}`;
        }

        if (options?.timeout) {
            config.timeout = options.timeout;
        }

        return httpClient(config);
    },

    getFastTrackUrls: ({accountId, templateId, params, options}: {accountId: string; templateId: string; params?: FastTrackUrlsParams; options?: ApiCallOptions}) =>
        createBulkApiCall<FastTrackUrlsResource>('GET', `accounts/${accountId}/templates/${templateId}/fast-track/urls`)({...options, params}),

    getFastTrackSending: ({accountId, templateId, options}: {accountId: string; templateId: string; options?: ApiCallOptions}) =>
        createBulkApiCall<FastTrackResource>('GET', `accounts/${accountId}/templates/${templateId}/fast-track/sending`)({...options}),

    getFastTrackSigning: ({accountId, templateId, options}: {accountId: string; templateId: string; options?: ApiCallOptions}) =>
        createBulkApiCall<FastTrackResource>('GET', `accounts/${accountId}/templates/${templateId}/fast-track/signing`)({...options}),

    storeFastTrack: ({accountId, templateId, data, options}: {accountId: string; templateId: string; data: StoreFastTrackRequest; options?: ApiCallOptions}) =>
        createBulkApiCall<StoreFastTrackResponse>('POST', `accounts/${accountId}/templates/${templateId}/fast-track`)({...options, data})
};
